import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreRoutingModule } from './core.routing';
import { VideoListComponent } from './components/video-list/video-list.component';
import { AnimeListComponent } from './components/anime-list/anime-list.component';
import { AnimeListService } from './services/anime-list.service';
import { BoxComponent } from './components/box/box.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule, MatProgressSpinnerModule, MatProgressBarModule, MatSliderModule, MatButtonModule } from '@angular/material';
import { ThumbDirective } from 'app/directives/thumb.directive';
import { Loader } from 'app/shared/loader/loader.component';
import { LoaderService } from 'app/shared/loader/loader.service';
import { PlayerComponent } from './components/player/player.component';
import { DelayResolve } from 'app/shared/delay.resolve';
import { IconAnimationDirective2 } from 'app/directives/icon-animation.directive';

@NgModule({
    declarations: [
        VideoListComponent,
        AnimeListComponent,
        BoxComponent,
        ThumbDirective,
        Loader,
        PlayerComponent,
        IconAnimationDirective2
    ],
    imports: [
        CommonModule,
        CoreRoutingModule,
        ReactiveFormsModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatSliderModule,
        MatButtonModule
    ],
    exports: [],
    providers: [
        AnimeListService,
        LoaderService,
        DelayResolve
    ],
})
export class CoreModule { }